export default "__VITE_ASSET__D5V3ilyi__"